var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.5C3.17157 10.5 2.5 9.82843 2.5 9L2.5 7.5C2.5 6.67157 3.17157 6 4 6L20 6C20.8284 6 21.5 6.67157 21.5 7.5V9C21.5 9.82843 20.8284 10.5 20 10.5V19.5C20 20.3284 19.3284 21 18.5 21H5.5C4.67157 21 4 20.3284 4 19.5L4 10.5ZM4 7.5L20 7.5V9L4 9L4 7.5ZM18.5 10.5L5.5 10.5L5.5 19.5H18.5V10.5Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.25C8.25 4.00736 9.25736 3 10.5 3C11.0763 3 11.6019 3.21664 12 3.57292C12.3981 3.21664 12.9237 3 13.5 3C14.7426 3 15.75 4.00736 15.75 5.25C15.75 6.49264 14.7426 7.5 13.5 7.5H12.75L12.75 21H11.25L11.25 7.5H10.5C9.25736 7.5 8.25 6.49264 8.25 5.25ZM11.25 6V5.25C11.25 4.83579 10.9142 4.5 10.5 4.5C10.0858 4.5 9.75 4.83579 9.75 5.25C9.75 5.66421 10.0858 6 10.5 6H11.25ZM12.75 5.25V6H13.5C13.9142 6 14.25 5.66421 14.25 5.25C14.25 4.83579 13.9142 4.5 13.5 4.5C13.0858 4.5 12.75 4.83579 12.75 5.25Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/Donation.2d3a60bd75831d83dde9b576e4a0a5f6.svg";
export { ForwardRef as ReactComponent };